import { useCallback, useEffect, useState } from 'react'
import { ApiError } from '@/lib/apiClient'
import { useApiClient } from '@/hooks/useApiClient'

export interface Iniciativa {
  id: string
  title: string
  organizacionId: string
  organizacionNombre: string | null
  descripcion: string | null
  responsable: string | null
  fechaObjetivo: string | null
  bloqueo: string | null
  resultado: string | null
  proximoPaso: { id: string; title: string; vencimiento: string | null } | null
}

export function useIniciativas() {
  const { gate, makeClient } = useApiClient()
  const [items, setItems] = useState<Iniciativa[]>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<ApiError | Error | null>(null)
  const [attempt, setAttempt] = useState(0)
  const reload = useCallback(() => setAttempt((value) => value + 1), [])

  useEffect(() => {
    if (gate !== 'ready') { setLoading(false); return }
    const client = makeClient(); if (!client) { setLoading(false); return }
    setLoading(true); setError(null)
    client.get<{ iniciativas: Iniciativa[] }>('/api/iniciativas').then((response) => setItems(response.iniciativas)).catch(setError).finally(() => setLoading(false))
  }, [gate, makeClient, attempt])

  const create = useCallback(async (input: { title: string; organizacionId: string; descripcion?: string; fechaObjetivo?: string }) => {
    const client = makeClient(); if (!client) throw new ApiError('API_UNAUTHORIZED', 'No hay sesión activa.')
    await client.post('/api/iniciativas', input); reload()
  }, [makeClient, reload])
  const update = useCallback(async (id: string, input: { bloqueo?: string | null; resultado?: string | null; fechaObjetivo?: string | null }) => {
    const client = makeClient(); if (!client) throw new ApiError('API_UNAUTHORIZED', 'No hay sesión activa.')
    await client.patch(`/api/iniciativas/${id}`, input); reload()
  }, [makeClient, reload])
  return { items, loading, error, reload, create, update }
}
